module.exports = __webpack_public_path__ + "assets/d46871fe6570b0b9c1260d900513150b.png";